import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { updatePassword } from 'aws-amplify/auth';
import { signIn, signOut } from 'aws-amplify/auth';
import { fetchUserAttributes } from 'aws-amplify/auth';
import { getCurrentUser } from 'aws-amplify/auth';
import { resetPassword } from 'aws-amplify/auth';
import { toast } from 'react-toastify';
import AdminNav from '../Homepage/Components/AdminNav';
import { useUser } from '../../UserContext';
import { LoginBackground } from "../../Constants/Backgrounds";
import { PasswordTurnVisibleIcon } from "../../Constants/Icons";
import { PasswordTurnInvisibleIcon } from "../../Constants/Icons";

const AdminLogin = () => {
    const navigate = useNavigate();
    const { setUserRole, setUser, setIsSignedIn } = useUser(); // Destructure setUser and setIsSignedIn from context


    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const [loading, setLoading] = useState(false);

    async function handleLogin(event) {
        event.preventDefault();
        setLoading(true);
        try {

            const { nextStep, signedIn } = await signIn({
                username: email,
                password: password,
            });

            if (nextStep.signInStep == 'CONFIRM_SIGN_UP') {
                showError("Please verify your email before logging in!");
                navigate('/vendors/validatePage');
            }
            if (nextStep.signInStep == 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
                const output = await resetPassword({ username: email });
                handleResetPasswordNextSteps(output);
            }

            const user = await getCurrentUser();
            const userAttributes = await fetchUserAttributes(['custom:userType']);

            //Setting this in the context, to verify later
            setUserRole(userAttributes['custom:userType']);
            
            if (userAttributes['custom:userType'] === 'vendor') {
                alert('You are trying to access the admin portal as an vendor!');
                await signOut();
                return;
            }

            setIsSignedIn(true);
            navigate('/admins/profile/vendors');

        } catch (error) {
            alert('Username/Password does not exist. Please try again.');
        }
        finally {
            setLoading(false);
        }
    }

    async function handleResetPasswordNextSteps(passIn) {
        try {

            const password = "Asdfwas1!"
            const challenge = "NEW_PASSWORD_REQUIRED"
            let username = "dirtyforgottendishrag@gmail.com"
            const { isSignUpComplete, nextStep } = await resetPassword(username)
        } catch (error) {
        }
    }

    const showError = (errorMessage) => {
        // const errorMessage = typeof error === 'string' ? error : 'Please Login To Continue.';
        toast.error(errorMessage, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [oldPassword, setOldPassword] = useState('');
    const [isOldPasswordVisible, setIsOldPasswordVisible] = useState(false);
    const toggleOldPasswordVisibility = () => {
        setIsOldPasswordVisible(!isOldPasswordVisible);
    };
    const handleOldPasswordChange = (e) => {
        const password = e.target.value;
        setOldPassword(password);
    }

    const [newPassword, setNewPassword] = useState('');
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const toggleNewPasswordVisibility = () => {
        setIsNewPasswordVisible(!isNewPasswordVisible);
    };

    const handleNewPasswordChange = (e) => {
        const password = e.target.value;
        setNewPassword(password);

        setHasNumber(/\d/.test(password));
        setHasSpecialChar(/[!@#$%^&*(),.?":{}|<>]/.test(password));
        setHasUppercase(/[A-Z]/.test(password));
        setHasLowercase(/[a-z]/.test(password));
        setIsPasswordMatch(confirmNewPassword === password); // Check match on confirm password change

    }
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const toggleConfirmPasswordVisibility = () => {
        setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
    };
    const handleConfirmPasswordChange = (e) => { // {{ edit_3 }}
        const confirmPassword = e.target.value;
        setConfirmNewPassword(confirmPassword);
        setIsPasswordMatch(newPassword === confirmPassword); // Check match on confirm password change
    }

    //States for checking password requirements 
    const [hasNumber, setHasNumber] = useState(false);
    const [hasSpecialChar, setHasSpecialChar] = useState(false);
    const [hasUppercase, setHasUppercase] = useState(false);
    const [hasLowercase, setHasLowercase] = useState(false);

    //State for checking if passwords match
    const [isPasswordMatch, setIsPasswordMatch] = useState(true);


    async function handleUpdatePassword(oldPassword, newPassword) {
        try {
            await updatePassword({ oldPassword, newPassword });
        } catch (err) {
        }
    }


    return (
        <div className="flex flex-col h-screen">
            <AdminNav />
            {loading && (
                <div className="fixed inset-0 bg-black opacity-50 flex justify-center items-center z-50">
                    <h2 className="text-white text-2xl">Please wait while we log you in</h2>
                </div>
            )}
            <div
                className="w-full h-full flex justify-center "
                style={{
                    backgroundImage: `url(${LoginBackground})`,
                    backgroundSize: 'cover',
                    position: 'relative'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-5 z-0" />
                <div className="sm:mt-12 w-full xs:w-[32rem] h-[34rem]  bg-white flex flex-col z-40">
                    <div className="px-16 py-10">
                        <h2 className="mt-8 text-2xl font-semibold"> Sign in</h2>
                        <h3 className="text-lg"> to access CharmHealthHub</h3>

                        <div className="mt-4 flex flex-col w-full">
                            <label className="w-full text-left font-medium text-base text-gray-800 mb-2">
                                Email
                            </label>
                            <input
                                type="email"
                                className="block py-2.5 px-4 w-full text-base text-gray-900 border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="mt-4 flex flex-col w-full">
                            <label className="w-full text-left font-medium text-base text-gray-800 mb-2">
                                Password
                            </label>
                            <div className="flex flex-row items-center relative">

                                <input
                                    type={isPasswordVisible ? 'text' : 'password'}
                                    className="block py-2.5 px-4 w-full text-base text-gray-900 border border-gray-300  appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 "
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute right-0 mr-4"
                                >
                                    {isPasswordVisible ? (
                                        <PasswordTurnVisibleIcon />

                                    ) : (
                                        <PasswordTurnInvisibleIcon />
                                    )}
                                </button>
                            </div>

                            {/* <div className="mt-6 w-full flex justify-end">
                                    <h3 className="">Forgot Password?</h3>
                                </div> */}
                            <button className="mt-6 text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit mx-auto rounded-full " onClick={handleLogin} >Sign In</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default AdminLogin;